export var successSnackbar = { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } };
export var errorSnackbar = { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } };
